import { EventFunction } from './base';

declare global {
  interface Window {
    googleTagManagerId: string | undefined;
    dataLayer: [
      { [key: string]: string | number | boolean | object | null | undefined }
    ];
  }
}

const trackEvent: EventFunction = async (eventName, eventData?) => {
  const trackConversionGoogleTagManager = window.dataLayer;

  if (trackConversionGoogleTagManager) {
    console.log('[Analytics_GoogleTagManager_Event]', { eventName, eventData });

    trackConversionGoogleTagManager.push({ ...eventData });
  }
};

const trackUser: EventFunction = async (eventName, eventData?) => {
  const trackConversionGoogleTagManager = window.dataLayer;

  const { userId } = eventData || { userId: '' };
  if (trackConversionGoogleTagManager) {
    console.log('[Analytics_GoogleTagManager_User]', { eventName, eventData });
    trackConversionGoogleTagManager.push({ uid: userId });
  }
};

export default { trackEvent, trackUser };
